import {
  Button,
  Card,
  DescriptionList,
  EmptyState,
  PageHeader,
  Skeleton,
  Table,
  StatusBadge,
} from "@evolua/ui";
import { useState } from "react";
import { QueryErrorState } from "../api/QueryErrorState.js";
import { useMeBenefit, useMeBenefits } from "../api/use-me.js";

/** Benefícios do colaborador (FASE-06-T38). */
export function BeneficiosPage() {
  const list = useMeBenefits();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const detail = useMeBenefit(selectedId);

  if (list.isPending) {
    return <Skeleton height="8rem" label="Benefícios" />;
  }

  if (list.isError || !list.data) {
    return <QueryErrorState error={list.error} onRetry={() => void list.refetch()} />;
  }

  if (!list.data.capabilityAvailable) {
    return (
      <>
        <PageHeader title="Benefícios" />
        <EmptyState
          title="Módulo indisponível"
          description="O ERP deste cliente não disponibiliza benefícios. Quando o módulo for contratado, eles aparecem aqui."
        />
      </>
    );
  }

  if (list.data.data.length === 0) {
    return (
      <>
        <PageHeader title="Benefícios" />
        <EmptyState
          title="Nenhum benefício ativo"
          description="Quando houver benefícios cadastrados no ERP, eles aparecerão nesta lista."
        />
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Benefícios"
        lead="Benefícios ativos vinculados ao seu vínculo. Detalhes vêm do ERP (mock-first)."
      />

      <Table
        caption="Benefícios"
        columns={[
          { id: "name", header: "Nome", cell: (item) => item.name },
          {
            id: "status",
            header: "Status",
            cell: (item) => <StatusBadge status={item.status} />,
          },
          {
            id: "category",
            header: "Categoria",
            cell: (item) => `${item.category} · ${item.type}`,
          },
          {
            id: "actions",
            header: "Ações",
            cell: (item) => (
              <Button
                type="button"
                size="sm"
                variant="secondary"
                onClick={() => setSelectedId(item.id)}
              >
                Abrir
              </Button>
            ),
          },
        ]}
        rows={list.data.data}
        getRowId={(item) => item.id}
      />

      {selectedId ? (
        <Card title="Detalhe" className="evolua-mt">
          {detail.isPending ? (
            <Skeleton height="4rem" />
          ) : detail.isError || !detail.data ? (
            <QueryErrorState error={detail.error} onRetry={() => void detail.refetch()} />
          ) : (
            <>
              <p>{detail.data.description}</p>
              <DescriptionList
                items={Object.entries(detail.data.attributes).map(([key, value]) => ({
                  term: key,
                  description: value,
                }))}
              />
              {detail.data.validFrom ? (
                <p className="evolua-page-lead">
                  Válido desde {detail.data.validFrom}
                  {detail.data.validTo ? ` até ${detail.data.validTo}` : ""}
                </p>
              ) : null}
            </>
          )}
        </Card>
      ) : null}
    </>
  );
}
